import { createContext, useState } from "react";

// ** Create Context
const ThemeContext = createContext({
  filterOpen       : false,
  handleFilterFocus: () => {}
});

const ThemeProvider = ({ children }) => {
  const [filterOpen, setFilterOpen] = useState(false);

  const handleFilterFocus = () => {
    setFilterOpen(!filterOpen);
  };

  return (
    <ThemeContext.Provider
      value={{
        handleFilterFocus,
        filterOpen
      }}
    >
      {children}
    </ThemeContext.Provider>
  );
};

export { ThemeContext, ThemeProvider };
